import { Card, Button, Badge } from "react-bootstrap";
import { DeleteButton } from "../../../components/DeleteButton/DeleteButton";
import { DisplayItem } from "../../../components/DisplayItem/DisplayItem";
import { EditButton } from "../../../components/EditButton/EditButton";
import { strings } from "../../../config/string";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloud, faBuilding, faFolderOpen, faProjectDiagram } from "@fortawesome/free-solid-svg-icons";
import { useNavigate } from "react-router-dom";
import { Office } from "types";

type Props = {
  office: Office;
  onClickEdit: () => void;
  onClickDelete: () => void;
  onClickFolders: () => void;
};

export const OfficeItem = ({ office, onClickEdit, onClickDelete }: Props) => {
  const navigate = useNavigate();

  const navigateToOrganization = () => {
    if (office.organizationId) {
      navigate(`/organisations/${office.organizationId}`);
    }
  };

  const navigateToFolders = () => {
    navigate(`/offices/${office.id}?view=folders`);
  };

  const navigateToProjects = () => {
    navigate(`/projects?officeId=${office.id}`);
  };

  return (
    <DisplayItem>
      <Card.Body>
        <Card.Title>{office.name}</Card.Title>
        <Card.Subtitle className="mb-2 text-white opacity-75">{office.description}</Card.Subtitle>
        <Card.Text>
          <Badge 
            className="bg-primary border-dark text-white p-2 opacity-100 me-2 cursor-pointer"
            onClick={navigateToOrganization}
            style={{ cursor: 'pointer' }}
          >
            <FontAwesomeIcon icon={faBuilding} className="me-1" />
            Organization
          </Badge>
          {office.foreignId && (
            <Badge className="border-dark text-white p-2 opacity-100 shadow bg-info rounded">
              <FontAwesomeIcon icon={faCloud} className="me-1" style={{ color: '#FFD700' }} />
              NCVIB-ID: {office.foreignId}
            </Badge>
          )}
        </Card.Text>
      </Card.Body>
      <Card.Footer className="pt-0">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <EditButton onClick={onClickEdit} />
            <DeleteButton onClick={onClickDelete} />
          </div>
          <div>
            <Button
              className="me-2 btn-sm"
              variant="outline-primary"
              onClick={navigateToFolders}
            >
              <FontAwesomeIcon icon={faFolderOpen} className="me-1" />
              {strings.showFolders}
            </Button>
            <Button
              className="btn-sm"
              variant="primary"
              onClick={navigateToProjects}
            >
              <FontAwesomeIcon icon={faProjectDiagram} className="me-1" />
              {strings.viewProjects}
            </Button>
          </div>
        </div>
      </Card.Footer>
    </DisplayItem>
  );
};
